import { styled } from '@slal/ui';
import { Accordion } from '@slal/ui/display';
import { ChevronDownIcon } from '@slal/ui/icons';

export const StyledAccordion = styled(Accordion)`
    border: none;
    border-radius: 0;
    background: none;
    margin: 0;

    div:not([role='alert']) {
        padding-left: 0;
        padding-bottom: 0;
        padding-right: 0;
        border: none;
    }

    div[role='button'] {
        padding-top: 0;
        border-bottom: 1px solid ${({ theme }) => theme.colors.neutral__light__30};
    }

    div[role='region'] > div:first-child {
        display: flex;
        flex-direction: column;
        gap: 16px;
    }

    h4 {
        font-weight: ${({ theme }) => theme.fonts.sansSerif.fontWeights.bold}!important;
        margin-bottom: ${({ theme }) => theme.space[4]}!important;
    }
`;

export const CardAccordionWrapper = styled.div`
    border: 1px solid #c3d7e3;
    border-radius: 10px;
    overflow: hidden;
`;

export const CardAccordionHeaderGroup = styled.div`
    display: flex;
    gap: ${({ theme: { space } }) => space[5]};
    align-items: center;
`;

export const CardAccordionHeader = styled.div<{ backgroundColor?: string; hasButton?: boolean }>`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: ${({ theme: { space } }) => space[5]};

    background-color: ${({ backgroundColor }) => (backgroundColor ? backgroundColor : 'transparent')};

    button {
        min-width: unset;
    }

    cursor: ${({ hasButton }) => (!hasButton ? 'pointer' : 'default')};
`;

export const CardAccordionHeaderContent = styled.div``;

export const CardAccordionBody = styled.div`
    padding: ${({ theme: { space } }) => space[5]};
    border-top: 1px solid #c3d7e3;
`;

export const StyledChevronDownIcon = styled(ChevronDownIcon)<{ isOpen?: boolean }>`
    transform: ${({ isOpen }) => (isOpen ? 'scaleY(-1)' : 'scaleY(1)')};
`;
